import ReportService from "../../../services/ReportService";
class JSLOverallFilter {
  momentToFormat = (m) => m.format("YYYY-MM-DD");

  async getJSLOverallReport(selectedDate) {
    try {
      const response = await ReportService.getJSLOverallReport(
        this.momentToFormat(selectedDate)
      );

      const { daily, overAll } = response;
      return { daily, overAll };
    } catch (error) {
      throw error;
    }
  }
}
const jslOverallFilter = new JSLOverallFilter();
export default jslOverallFilter;
